// extracted by mini-css-extract-plugin
export default {"list":"style_list__O0UTg","preview":"style_preview__2j9b4"};